import { Tooltip } from "bootstrap";
import { ComponentOptions } from "bootstrap/js/dist/base-component";
import { useEffect, useRef } from "react";

export const useTooltip = (props: {
    title?: string;
    placement?: "bottom" | "top" | "left" | "right";
    disabled?: boolean;
}) => {
    const { title, placement, disabled } = props;

    const tooltipRef = useRef<HTMLDivElement & HTMLButtonElement>(null);

    useEffect(() => {
        if (tooltipRef.current && title) {
            const options: ComponentOptions = {
                title,
                trigger: "hover",
                strategy: "fixed",
            };

            if (placement) {
                options.placement = placement;
            }

            const t = Tooltip.getOrCreateInstance(tooltipRef.current, options);

            if (title && !disabled) {
                t.enable();
            } else {
                t.disable();
            }

            return () => {
                t.dispose();
            };
        }

        return () => null;
    }, [disabled, placement, title]);

    return { tooltipRef };
};
